module.exports = __webpack_public_path__ + "img/02uni-doll.2305dbdf.png";